goog.provide("shadow.js.shim.module$src$svg$wpp$content$people_svg$default");
shadow.js.shim.module$src$svg$wpp$content$people_svg$default = shadow.js.shim.module$src$svg$wpp$content$people_svg.default;
